import { render, staticRenderFns } from "./CreatorGalleryShare.vue?vue&type=template&id=0c45a6a1&"
import script from "./CreatorGalleryShare.vue?vue&type=script&lang=js&"
export * from "./CreatorGalleryShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports